import QuestionsMessage from '../../../../../pages/vip/features/quotation-message/quotation-limit-message';

export default QuestionsMessage;
